import { toast } from "sonner";
import { FileDown } from "lucide-react";
import { useApi, downloadBlob } from "@/lib/api";

const GUIDES = [
  { kind: "flight", label: "Flight department workflow guide", file: "JetSet-Flight-Department-Workflow-Guide.pdf", staffOnly: true },
  { kind: "broker", label: "Broker workflow guide", file: "JetSet-Broker-Workflow-Guide.pdf" },
];

export function HelpGuides({ staff }) {
  const api = useApi();
  const get = (g) => downloadBlob(api, `/guides/${g.kind}.pdf`, g.file).catch(() => toast.error("Couldn't download the guide"));
  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-2 mt-4" data-testid="help-guides">
      <span className="uppercase tracking-[0.2em] text-[10px] text-zinc-500">Help</span>
      {GUIDES.filter((g) => staff || !g.staffOnly).map((g) => (
        <button key={g.kind} type="button" onClick={() => get(g)} className="inline-flex items-center gap-1.5 text-zinc-400 hover:text-[#C6A55C] underline-offset-4 hover:underline"
          data-testid={`help-guide-${g.kind}-btn`}>
          <FileDown size={12} /> {g.label}
        </button>
      ))}
    </div>
  );
}
